import { getCurrentLocaleCode } from "@mongez/localization";

export function getLocalizedValue(
  value: any,
  localeCode: string = getCurrentLocaleCode(),
  localeCodeKey = "localeCode",
  textKey = "value",
) {
  if (!value) return "";

  if (value[localeCode]) return value[localeCode];

  if (Array.isArray(value)) {
    return (
      value.find((item) => item[localeCodeKey] === localeCode)?.[textKey] ||
      value?.[0]?.[textKey]
    );
  }

  return value;
}
